<template>
	<nk-wrapper v-if="!user" spacing="md">
		<nk-form
			:success="success"
			:error="error"
			success-message="Ihre Anmeldung war erfolgreich"
			success-description="Sie haben sich erfolgreich angemeldet"
			error-message="Leider ist ein Fehler beim Anmelden aufgetreten"
			:error-description="`Bitte kontrollieren Sie Ihre Eingabe.`"
			name="ratsinfologinformular"
			:schema="schema"
			@submit="processForm"
		/>
	</nk-wrapper>
</template>

<script>
export default {
	name: 'NkTemplateRatsinfosystemLogin',

	data() {
		return {
			form: null,
			error: false,
			success: false,
			schema: [
				{
					component: 'h2',
					class: 'text-xl my-4',
					children: 'Anmeldung',
					id: 'headline-1',
				},
				{
					component: 'div',
					class: 'flex flex-wrap -m-2',
					id: 'wrapper-1-1',
					children: [
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-1-3',
							children: [
								{
									type: 'email',
									label: 'E-Mail Adresse',
									placeholder: 'max.mustermann@beispiel.de',
									name: 'email',
									validation: 'required|email',
								},
							],
						},
						{
							component: 'div',
							class: 'w-full p-2',
							id: 'col-1-2',
							children: [
								{
									type: 'password',
									label: 'Passwort',
									placeholder: '••••••••',
									name: 'passwort',
									validation: 'required|min:2',
								},
							],
						},
					],
				},
				{
					component: 'div',
					class: 'flex flex-wrap -m-2',
					id: 'wrapper-6',
					children: [
						{
							component: 'div',
							class: 'w-auto  p-2',
							id: 'col-6-1',
							children: [
								{
									type: 'submit',
									name: 'Anmelden',
								},
							],
						},
					],
				},
			],
		};
	},

	computed: {
		user() {
			return this.$store.state.nuxtKommunen.ratsinfoauth.user;
		},
	},

	methods: {
		resetForm() {
			this.form = null;
			this.error = false;
			this.success = false;
		},

		processForm(form) {
			this.form = form;
			this.loginRat();
		},

		async loginRat() {
			const isLoggedIn = await this.$store.dispatch(
				'nuxtKommunen/ratsinfoauth/login',
				{
					...this.form,
				},
			);

			this.error = !isLoggedIn;

			if (isLoggedIn) {
				this.$router.push(this.$route.path);
			}
		},
	},
};
</script>
